<div class="control-panel ag-pa-md">
  <div
    *ngIf="(searchHistrory === null || searchHistrory === undefined) && !loading"
    class="hist-unavailable"
  >
    <h6>Search History unavailable</h6>
  </div>
  <div *ngIf="loading" style="margin-top: 50px; margin-left: 185px">
    <mat-spinner strokeWidth="3" color="accent" [diameter]="25"></mat-spinner>
  </div>
  <div *ngIf="searchHistrory && !loading">
    <div class="slide-notify" style="width: 400px">
      <h6 class="width-100" style="font-size: 1em">
        Your Search History ({{ currentSaveSearches }} of {{ maxSaveSearches }} saved)
        <i
          class="fa fa-times pull-right close-sidenav"
          aria-hidden="true"
          title="Close Text Block"
          (click)="closeNav()"
        ></i>
        <i aria-hidden="true" class="fa fa-trash" (click)="clear()" style="margin-left: 10px"></i>
      </h6>
      <hr style="border-color: var(--header-color); width: 100%" />
      <mat-card class="history-card" *ngFor="let item of searchHistrory; let i = index">
        <mat-card-content>
          <div class="width-100" *ngFor="let data of item.displayInfo?.searchTerms">
            <div class="width-100">
              <span class="key">Search Term:</span>
              <span class="value">{{ data?.searchTerm }}</span>
            </div>
            <div class="width-100">
              <span class="key">Search Index:</span>
              <span class="value">{{ data?.searchIndex }}</span>
            </div>
            <div class="width-100">
              <span class="key">Resource(s):</span>
              <span class="value"> {{ item.displayInfo?.resources.length }} Selected</span>
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions class="text-end">
          <button
            role="button"
            type="button"
            aria-label="Search"
            class="history-action btn btn-sm btn-primary"
            (click)="search(item.searchInfo)"
          >
            Search
          </button>
          <button
            *ngIf="(sharedService.kidsCat$ | async) === false"
            role="button"
            type="button"
            aria-label="Modify"
            class="btn btn-sm btn-primary"
            (click)="modify(item.searchInfo)"
          >
            Modify
          </button>
          <button
            role="button"
            type="button"
            aria-label="More Details"
            class="btn btn-sm btn-primary"
            (click)="moreDetails(item.displayInfo)"
          >
            More Details
          </button>
        </mat-card-actions>
        <hr style="border-color: var(--header-color); width: 100%" />
      </mat-card>
    </div>
  </div>
</div>
